var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#e8eef2"}},[_c('PCNavbar',{attrs:{"selectIndex":"2"}}),_c('MobileNavBar',{attrs:{"currentActive":1}}),_c('Yaowen'),_c('CallMe'),_c('MobileCallme')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }